import { render, staticRenderFns } from "./FornecedorList.vue?vue&type=template&id=0502e2b2&scoped=true"
import script from "./FornecedorList.vue?vue&type=script&lang=js"
export * from "./FornecedorList.vue?vue&type=script&lang=js"
import style0 from "./FornecedorList.vue?vue&type=style&index=0&id=0502e2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502e2b2",
  null
  
)

export default component.exports